import React from 'react';
import styled from 'styled-components';

import { Text, List, ListItem } from 'components/chroma';

import {
  productDisclosureStatementUrl,
  roadsideAssistTermsCondition,
} from 'scenes/common/helpers/contacts';

const StyledListWrapper = styled.div`
  ul {
    margin-bottom: 1rem;
  }
`;

export const hireCarInformation = () => (
  <Text>
    If you are without your car due to a covered incident, we will pay for the
    cost of a hire car (up to $75 per day) for up to 14 days. For full details,
    see the{' '}
    <a
      href={productDisclosureStatementUrl()}
      target="_blank"
      rel="noopener noreferrer"
    >
      Product Disclosure Statement
    </a>
    .
  </Text>
);

export const windscreenInformation = () => (
  <Text>
    We will pay for one replacement or repair of your windscreen, sunroof or
    window glass per year, without charging you an excess. For full details, see
    the&nbsp;
    <a
      href={productDisclosureStatementUrl()}
      target="_blank"
      rel="noopener noreferrer"
    >
      Product Disclosure Statement
    </a>
    .
  </Text>
);

export const under25Information = () => (
  <div>
    <Text>
      Including cover for drivers under the age of 25 will increase your
      premium.
    </Text>
    <Text>
      (Not required for learner drivers as long as the supervising driver’s age
      is 25 years or older).
    </Text>
  </div>
);

const roadsideAssistCovers = [
  '24 hour telephone help',
  '24 hour road service',
  'Jump-starting or arranging a replacement battery',
  'Changing a flat tyre',
  'Arranging emergency fuel',
  'Towing to your preferred repairer (free towing for first 20km in metropolitan locations or 50km in regional and remote locations)',
  'Providing advice after an accident',
  'Relaying urgent messages to your family, friends or workplace',
  'Your roadside assistance coverage starts on whichever is the later of insurance cover start date or 24 hours after purchase date',
];

export const roadsideAssistInformation = () => (
  <>
    <Text>Our roadside assistance service covers:</Text>
    <StyledListWrapper>
      <List bullet>
        {roadsideAssistCovers.map((item) => (
          <ListItem key={item}>
            <Text>{item}</Text>
          </ListItem>
        ))}
      </List>
    </StyledListWrapper>
    <Text>
      For the full details, see the Roadside Assistance{' '}
      <a
        href={roadsideAssistTermsCondition()}
        target="_blank"
        rel="noopener noreferrer"
      >
        Terms and Conditions
      </a>
      .
    </Text>
  </>
);
